import React from 'react';
import { useSelector } from 'react-redux';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { useDefaultLayout } from 'hooks/useDefaultLayout';
import { getIsTopHeaderHidden, getSearchDesktopHeaderHeight } from 'modules/search/selectors';
import { LayoutType } from 'modules/search/types';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import { COMPACT_HEADER_TOP_HEIGHT } from '@daedalus/atlas/Header';
import { Flex } from '@daedalus/atlas/helpers/Flex';
// Temporary fix to avoid removing the node from the DOM
const withHiddenStyles = "w4g7czs";
const _exp = /*#__PURE__*/() => Flex.Column;
const ListWrapper = /*#__PURE__*/styled(_exp())({
  name: "ListWrapper",
  class: "lqlq8k1",
  propsAsIs: true
});
const MapWrapper = /*#__PURE__*/styled('div')({
  name: "MapWrapper",
  class: "m1gug9y7",
  propsAsIs: false
});
const splitLayoutStyles = "s19sdo4e";
const mapLayoutStyles = "mhvd0vf";
const listLayoutStyles = "l1h5vh51";
interface Props {
  listComponent: React.ReactNode;
  mapComponent: React.ReactNode;
}

/**
 * Container to handle which type of view to display
 */
export const SearchLayoutContainer: React.FC<Props> = ({
  listComponent,
  mapComponent
}) => {
  const {
    layout,
    isListVisible,
    isMapVisible
  } = useDefaultLayout();
  const searchDesktopHeaderHeight = useSelector(getSearchDesktopHeaderHeight);
  const topHeaderIsHidden = useSelector(getIsTopHeaderHidden);
  const {
    isMobile
  } = useDeviceLayout();
  const topHeaderHeight = COMPACT_HEADER_TOP_HEIGHT;
  const searchDesktopHeaderHeightValue = topHeaderIsHidden ? searchDesktopHeaderHeight - topHeaderHeight // when the top header is hidden we need to fill the space. This is needed to make the map grow on the SRP
  : searchDesktopHeaderHeight;
  return <main className={cx(layout === LayoutType.LIST && listLayoutStyles, layout === LayoutType.MAP && mapLayoutStyles, layout === LayoutType.SPLIT && splitLayoutStyles)} style={{
    // @ts-expect-error -- need to find a way to type this
    '--searchDesktopHeaderHeight': searchDesktopHeaderHeightValue + 'px'
  }}>
      <ListWrapper className={cx(!isListVisible && withHiddenStyles)}>
        {listComponent}
      </ListWrapper>
      {isMapVisible && !isMobile && <MapWrapper>{mapComponent}</MapWrapper>}
    </main>;
};

require("./index.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");